import * as S from './style'; 

export function SearchIcon() {
    return <S.SearchIcon>
        <S.CustomIcon icon="search"/>
    </S.SearchIcon>
}